import { IOH } from './environment';

export class Endpoints {
  getGenericEndpoints() {
    return {
      getUsers: IOH.userServiceBaseURL + '/user/pagination',
      userActive: IOH.userServiceBaseURL + '/user/active',
      findUserByEmail: IOH.userServiceBaseURL + '/user/email',
      emailExists: IOH.userServiceBaseURL + '/user/userEmail',
      telemetryTunnel: IOH.patientServiceBaseURL + '/patient/telemetry',
      getUserStatusExportData: IOH.reportsServiceBaseUrl + '/patient/reports/deletedUsersReport',
      temporaryPassword: IOH.userServiceBaseURL + '/user/reset-password',
      confirmForgotPassword: IOH.userServiceBaseURL + '/auth/confirm-forgot-password',
      uploadFile: IOH.userServiceBaseURL + '/user/upload-file',
      bulkUpload: IOH.userServiceBaseURL + '/user/bulk-upload',
      uploadTemplate: IOH.userServiceBaseURL + '/user/upload-template',
      updateUser: IOH.userServiceBaseURL + '/user/update',
      updateUserRegistrationStatus: IOH.userServiceBaseURL + '/user/update-registration-status',
      deleteUser: IOH.userServiceBaseURL + '/auth/delete',
      deleteFile: IOH.userServiceBaseURL + '/user/delete-file',
      searchUsers: IOH.userServiceBaseURL + '/user/search',
      profile: IOH.userServiceBaseURL + '/user/profile',
      updatePermissionsEmail: IOH.userServiceBaseURL + '/user/update-permissions-email',
      getAgencies: IOH.userServiceBaseURL + '/agency',
      checkIsEdocEnabled: IOH.userServiceBaseURL + '/agency/isEDocEnabled',
      getAgenciesWithSearch: IOH.userServiceBaseURL + '/agency/getAgencies',
      getAgencyTemplates: IOH.userServiceBaseURL + '/agency/templates',
      createUser: IOH.userServiceBaseURL + '/auth/register',
      getUserRole: IOH.userServiceBaseURL + '/user/role',
      createAgency: IOH.userServiceBaseURL + '/agency',
      getAgenciesByRole: IOH.userServiceBaseURL + '/agency/by-role',
      getUsersWithSearch: IOH.userServiceBaseURL + '/user/getUsers',
      getEsocPatientsWithSearch: IOH.userServiceBaseURL + '/esoc-patient/patients',
      getEsocPatientsSubmissions: IOH.userServiceBaseURL + 'esoc-patient/submissions',
      resendEsocEmail: IOH.userServiceBaseURL + '/patient/send-esoc-email',
      processEsocRequest: IOH.patientServiceBaseURL + '/patient_esoc/processEsocRequest',
      processEsocResendRequest: IOH.userServiceBaseURL + '/patient/process-esoc-resend-request',
      resendEsocSms: IOH.userServiceBaseURL + '/patient/send-esoc-sms',
      esocVerification: IOH.userServiceBaseURL + '/esoc-verification/',
      deleteAgency: IOH.userServiceBaseURL + '/agency/',
      findAgencyByEmail: IOH.userServiceBaseURL + '/agency/email',
      updateAgency: IOH.userServiceBaseURL + '/agency/update',
      getPatientSubmissions: IOH.patientServiceBaseURL + '/patient/patientSubmissions',
      getSubmissionByPatient: IOH.patientServiceBaseURL + '/patient_visit/getSubmissionByPatients',
      getAllVisits: IOH.patientServiceBaseURL + '/patient_visit/getAllVisits',
      getAllVisitsWithRules: IOH.cdsServiceBaseUrl + '/qa_scrubber/getAll',
      qaScrubberFlagAction: IOH.cdsServiceBaseUrl + '/qa_scrubber/flags/',
      qaScrubberV4Charts: IOH.cdsServiceBaseUrl + '/qa_scrubber/v4/charts',
      qaScrubberV4FindingAction: IOH.cdsServiceBaseUrl + '/qa_scrubber/v4/findings/',
      logshipStatus: IOH.cdsServiceBaseUrl + '/qa_scrubber/logship-status',
      supportTicket: IOH.userServiceBaseURL + '/user/support',
      updateSupport: IOH.userServiceBaseURL + '/user/support/update',
      support: IOH.userServiceBaseURL + '/user/support/all',
      uploadeSocFile: IOH.patientServiceBaseURL + '/patient_esoc/uploadFile',
      updatePatientSubmissionEsoc: IOH.patientServiceBaseURL + '/patient_esoc/updatePatienteSoc',
      updateStatus: IOH.patientServiceBaseURL + '/patient_visit/',
      eSocPatientSubmissions: IOH.patientServiceBaseURL + '/patient/eSoc-patient-submissions',
      changeConsent: IOH.patientServiceBaseURL + '/patient/changeConsent',
      getUserEsocPatientSubmissions: IOH.userServiceBaseURL + '/user/getUserEsocPatientSubmissions',
      deleteEsockFile: IOH.patientServiceBaseURL + '/patient_visit/delete-eSock-file',
      createNotification: IOH.patientServiceBaseURL + '/patient/push-notification',
      getNotification: IOH.patientServiceBaseURL + '/patient/push-notification/getNotifications',
      updateNotifications: IOH.patientServiceBaseURL + '/patient/push-notification/updateNotifications',
      getPatientsWithCaseManagerName: IOH.patientServiceBaseURL + '/patient/getCaseManagerNames',
      fin: IOH.rulesServiceBaseUrl + '/engine/api/fin/v1/process',
      findAllRules: IOH.rulesServiceBaseUrl + '/rule/h1',
      createRule: IOH.rulesServiceBaseUrl + '/rule/h1',
      updateRule: IOH.rulesServiceBaseUrl + '/rule/h1',
      getSubmissionWithOutPatients: IOH.patientServiceBaseURL + '/patient_visit/getSubmissionWithOutPatients',
      getPatientCreatedByNames: IOH.patientServiceBaseURL + '/patient/getPatientCreatedByNames',
      getAgencyInformation: IOH.userServiceBaseURL + '/agency/agency-information',
      getPatientEsocListing: IOH.patientServiceBaseURL + '/patient_esoc/patientEsocListing',
      getPatientEsocById: IOH.patientServiceBaseURL + '/patient_esoc/getPatientEsocById',
      getAutofillData: IOH.patientServiceBaseURL + '/patient_esign/getAutofillData',
      deleteESocFile: IOH.patientServiceBaseURL + '/patient_esoc/deleteESocFile',
      processEphResendRequest: IOH.patientServiceBaseURL + '/patient_esoc/process-eph-resend-request',
      getEPHfileObjectUrl: IOH.patientServiceBaseURL + '/patient_esign/get-eph-file-url',
      reProcessSubmission: IOH.patientServiceBaseURL + '/patient_visit/reprocessSubmission',
      patientESOCExportData: IOH.patientServiceBaseURL + '/patient_esoc/patientESOCExportData',
      getCompanies: IOH.userServiceBaseURL + '/company/getCompanies',
      createCompany: IOH.userServiceBaseURL + '/company',
      updateCompany: IOH.userServiceBaseURL + '/company',
      findCompanyByEmailOrId: IOH.userServiceBaseURL + '/company/findBy',
      deleteCompany: IOH.userServiceBaseURL + '/company',
      getAgencyErrorsAndWarningsExportData: IOH.reportsServiceBaseUrl + '/patient/reports/errors-warnings',
      getCompanyErrorsAndWarningsExportData: IOH.reportsServiceBaseUrl + '/patient/reports/company-utilization-stats',
      getCompanyUtilizationExportData: IOH.reportsServiceBaseUrl + '/patient/reports/company-report',
      getIohCompanyUsersExportData: IOH.reportsServiceBaseUrl + '/patient/reports/ioh-company-users',
      createPatient: IOH.patientServiceBaseURL + '/patient/',
      deletePatient: IOH.patientServiceBaseURL + '/patient/deletePatient',
      bulkUploadPatient: IOH.patientServiceBaseURL + '/patient/bulk-upload',
      getBulkPatientTemplate: IOH.patientServiceBaseURL + '/patient/get-bulk-patient-template',
      uploadCoordinationNote: IOH.patientServiceBaseURL + '/patient/opt-preference-upload',
      exportEmergencyPreparednessReport: IOH.patientServiceBaseURL + '/patient/reports/emergency-preparedness',
      exportEmergencyPreparednessContactInformationReport: IOH.patientServiceBaseURL + '/patient/reports/emergency-preparedness-contact-information',
      generateIOHUserReport: IOH.reportsServiceBaseUrl + '/patient/reports/ioh-users',
      heartbeat: IOH.patientServiceBaseURL + '/patient/heartbeat',
      getClinicianList: IOH.patientServiceBaseURL + '/patient_visit/getClinicianList',
      getCaseManagerList: IOH.patientServiceBaseURL + '/patient/getCaseManagerList',
      readCSVFile: IOH.patientServiceBaseURL + '/file-parse/readCSVFile',
      releaseVersion: IOH.userServiceBaseURL + '/user/release-version',
      forceResetPassword: IOH.userServiceBaseURL + '/auth/force-change-password',
      updateEsocFileStatus: IOH.patientServiceBaseURL + '/patient_esoc/updateEsocFileStatus',
      ssoMicrosoftLogin: IOH.userServiceBaseURL + '/auth/sso-authorize',
      ssoMicrosoftLogout: IOH.userServiceBaseURL + '/auth/sso-logout',
      checkFileValidity: IOH.patientServiceBaseURL + '/patient_esoc/file-validity',
      checkEDocLinkValidity: IOH.patientServiceBaseURL + '/patient_esoc/check-eDoc-link',
      sendEsign: IOH.patientServiceBaseURL + '/patient_esign/send_esign',
      esignStreamUrl: IOH.patientServiceBaseURL + '/patient_esign/view-pdf',
      getEsignLinkDetails: IOH.patientServiceBaseURL + '/patient_esign/esign_link_details',
      verifyEsignDob: IOH.patientServiceBaseURL + '/patient_esign/verify_esign_dob',
      signDocument: IOH.patientServiceBaseURL + '/patient_esign/sign_document',
      getEsignHistory: IOH.patientServiceBaseURL + '/patient_esign/esign_history',
      logEsignAuditEvent: IOH.patientServiceBaseURL + '/patient_esign/audit_log',
      esignServerTime: IOH.patientServiceBaseURL + '/patient_esign/server_time',
      uploadHosAddendum: IOH.patientServiceBaseURL + '/hos_addendum/upload',
      sendHosAddendum: IOH.patientServiceBaseURL + '/hos_addendum/send',
      retractHosAddendum: IOH.patientServiceBaseURL + '/hos_addendum/retract',
      getHosAddendumHistory: IOH.patientServiceBaseURL + '/hos_addendum/history',
      getHosAddendumSigningLink: IOH.patientServiceBaseURL + '/hos_addendum/signing-link',
      checkHosAddendumEnabled: IOH.userServiceBaseURL + '/agency/hos-check-enabled',
      setHosAddendumSocDate: IOH.patientServiceBaseURL + '/hos_addendum/soc-date',
      // The agency service lists an agency's addendum email and fax; adding, verifying, switching and
      // removing them stay in the patient service, the only one that has those routes.
      hosAddendumDeliveryDestinationList: IOH.userServiceBaseURL + '/agency/hos-delivery-destinations',
      hosAddendumDeliveryDestinations: IOH.patientServiceBaseURL + '/agency/hos-delivery-destinations',
      clinicianChangeReport: IOH.reportsServiceBaseUrl + '/patient/reports/clinician-change-report',
      clinicianSuggestionCalReport: IOH.reportsServiceBaseUrl + '/patient/reports/clinician-suggestions-stats',
      getBulkUploadUserTemplate: IOH.userServiceBaseURL + '/user/get-bulk-user-template',
      userActivationReport: IOH.reportsServiceBaseUrl + '/patient/reports/usersActivationReport',
      sendActivationEmail: IOH.userServiceBaseURL + '/user/send-activation-email',
      generate2faSecret: IOH.userServiceBaseURL + '/user/generate-totp-secret',
      getTotpSecret: IOH.userServiceBaseURL + '/user/get-totp-secret',
      verifyTotp: IOH.userServiceBaseURL + '/user/verify-totp-secret',
      sendOrgIdByEmail: IOH.userServiceBaseURL + '/user/send-email-orgId',
      getFormData: IOH.userServiceBaseURL + '/user/form-data',
      createFormData: IOH.userServiceBaseURL + '/user/create-form-data',
      deleteFormData: IOH.userServiceBaseURL + '/user/delete-form-data',
      // IOHB-1737 — app configs served to the Android app. `appConfig` is the
      // base; :id is appended by the service for get/update/delete.
      appConfig: IOH.userServiceBaseURL + '/user/app-config',
      appConfigList: IOH.userServiceBaseURL + '/user/app-config/list',
      appConfigPublish: IOH.userServiceBaseURL + '/user/app-config/publish',
      ioAlertReport: IOH.reportsServiceBaseUrl + '/patient/reports/generateFinancialScoreReport',
      warningReport: IOH.reportsServiceBaseUrl + '/patient/reports/warnings',
      popupReport: IOH.reportsServiceBaseUrl + '/patient/reports/popup',
      oasisReport: IOH.reportsServiceBaseUrl + '/patient/reports/oasis',
      agencyComparisonReport: IOH.reportsServiceBaseUrl + '/patient/reports/comparisonReport',
      clinicianAnalysisReport: IOH.reportsServiceBaseUrl + '/patient/reports/clinicianAnalysisReport',
      getReportsList: IOH.userServiceBaseURL + '/user/reports/getReportsList',
      downloadReport: IOH.userServiceBaseURL + '/user/reports/download-file',
      shareReport: IOH.userServiceBaseURL + '/user/reports/generate-email-link',
      validateReportLink: IOH.userServiceBaseURL + '/user/reports/validate-report',
      downloadReportWithCode: IOH.userServiceBaseURL + '/user/reports/download',
      deleteReport: IOH.userServiceBaseURL + '/user/reports/deleteReport',
      regenerateReport: IOH.userServiceBaseURL + '/user/reports/regenerate-report',
      updatePreQaCheck: IOH.patientServiceBaseURL + '/patient_visit/update_pre_qa_check_data',
      createMedicationAlert: IOH.userServiceBaseURL + '/medication-alerts',
      getMedicationAlertsByAgency: IOH.userServiceBaseURL + '/medication-alerts',
      getMedicationAlertById: IOH.userServiceBaseURL + '/medication-alerts',
      updateMedicationAlert: IOH.userServiceBaseURL + '/medication-alerts/update',
      deleteMedicationAlert: IOH.userServiceBaseURL + '/medication-alerts',
      bulkDeleteMedicationAlerts: IOH.patientServiceBaseURL + '/medication-alerts/bulk',
      checkMedicationAlert: IOH.userServiceBaseURL + '/medication-alerts/check',
      medicationAlertsBatchUpload: IOH.patientServiceBaseURL + '/medication-alerts/batch-upload',
      getBatchMedicationTemplate: IOH.patientServiceBaseURL + '/medication-alerts/get-batch-medication-template',
      // Email / APK distribution
      sendApkEmailToUser: IOH.userServiceBaseURL + '/user/sendApkEmail',
      sendBulkEmailToCompany: IOH.userServiceBaseURL + '/company/sendBulkEmail',
      sendBulkEmailToAgency: IOH.userServiceBaseURL + '/agency/sendBulkEmail',
      // App Link (APK) management
      uploadApk: IOH.userServiceBaseURL + '/apk-link/upload-apk',
      getApkLinks: IOH.userServiceBaseURL + '/apk-link/apkData',
      createApkLink: IOH.userServiceBaseURL + '/apk-link/apkData',
      updateApkLink: IOH.userServiceBaseURL + '/apk-link/apkData',
      deleteApkLink: IOH.userServiceBaseURL + '/apk-link/apkData',
      uploadLayout: IOH.userServiceBaseURL + '/layouts/upload',
      getLayouts: IOH.userServiceBaseURL + '/layouts',
      updateLayout: IOH.userServiceBaseURL + '/layouts/update',
      deleteLayout: IOH.userServiceBaseURL + '/layouts',
      quicksight: IOH.userServiceBaseURL + '/quicksight/dashboard-url',
      quicksightList: IOH.userServiceBaseURL + '/quicksight/dashboard-list',
      companyDashboard: IOH.userServiceBaseURL + '/quicksight/company-dashboard-url',
      insightsCompaniesList: IOH.userServiceBaseURL + '/quicksight/companies',
      isIOInsightEnabled: IOH.userServiceBaseURL + '/company/isIOInsightEnabled',
      getAiComposerNarrativeTemplates: IOH.userServiceBaseURL + '/prompt-templates/narrative',
      createAiComposerNarrativeTemplate: IOH.userServiceBaseURL + '/prompt-templates/narrative',
      updateAiComposerNarrativeTemplate: IOH.userServiceBaseURL + '/prompt-templates/narrative',
      deleteAiComposerNarrativeTemplate: IOH.userServiceBaseURL + '/prompt-templates/narrative',
      getAiComposerNarrativeTemplateHistory: IOH.userServiceBaseURL + '/prompt-templates/narrative',
      getAiComposerNotesTemplates: IOH.userServiceBaseURL + '/prompt-templates/notes',
      createAiComposerNotesTemplate: IOH.userServiceBaseURL + '/prompt-templates/notes',
      updateAiComposerNotesTemplate: IOH.userServiceBaseURL + '/prompt-templates/notes',
      deleteAiComposerNotesTemplate: IOH.userServiceBaseURL + '/prompt-templates/notes',
      getAiComposerNotesTemplateHistory: IOH.userServiceBaseURL + '/prompt-templates/notes',
      getAiComposerVisitTypes: IOH.userServiceBaseURL + '/prompt-templates/ioh-visit-types',
    };
  }
}
